<template>
  <div :class="{ pressed }" class="tick" @click="press">
    <font-awesome-icon :icon="faCheck" class="tick-icon" />
  </div>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';

const props = defineProps({
  pressed: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:pressed']);

function press() {
  emit('update:pressed', !props.pressed);
}
</script>

<style scoped lang="scss">
@use '@/scss/main.scss';

.tick {
  height: 20px;
  width: 20px;
  position: relative;
  color: main.$blue-903_01;
  cursor: pointer;
  background: main.$blue-901_02;
  border-radius: 3px;
  font-size: main.$font-size-xs;

  .tick-icon {
    opacity: 0;
    position: absolute;
    left: 4px;
    top: 4px;
    transition: opacity ease-in-out 0.2s;
  }

  &.pressed {
    .tick-icon {
      opacity: 1;
    }
  }
}
</style>
